import { render } from "./ConsultationFeeDialog.vue?vue&type=template&id=d877f09a&scoped=true"
import script from "./ConsultationFeeDialog.vue?vue&type=script&lang=js"
export * from "./ConsultationFeeDialog.vue?vue&type=script&lang=js"

import "./ConsultationFeeDialog.vue?vue&type=style&index=0&id=d877f09a&lang=css"
import "./ConsultationFeeDialog.vue?vue&type=style&index=1&id=d877f09a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d877f09a"]])

export default __exports__